import { Component }              from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataProvider }           from "../../services/data/data";
import { PHBGlobals }             from "../../../_config/config";

/**
 * Start page with general information about Planerhandbuch.
 */
@Component({
	selector: "page-home",
	templateUrl: "home.html",
	styleUrls: ["home.scss"]
})
export class HomePage {

	warning: boolean = false;

	constructor(private router: Router,
		private data: DataProvider,
		route: ActivatedRoute
	) {
		route.params.subscribe(async () => {
			await this.init();
		});
	}

	async init() {
		if(PHBGlobals.dataSuccessfulLoaded) {
			const logon:string = localStorage.getItem('phb-logon');
			if(logon){
				const target = localStorage.getItem('phb-redirect-after-login');
				if(target){
					const parsed = JSON.parse(target);
					if(parsed.isoCode) {
						await this.router.navigate(["node", parsed.isoCode, parsed.id]);
					}else{
						await this.router.navigate(["node", parsed.id]);
					}
					localStorage.removeItem('phb-logon');
					localStorage.removeItem('phb-redirect-after-login');
					return;
				}
			}

			const sectionId:string = localStorage.getItem(`phb-section-${PHBGlobals.user.sessionHash}`) || this.data.currentSection();

			console.log("open node", sectionId);
			if (sectionId) {
				await this.router.navigate(["node", sectionId]);
			} else {
				this.warning = true;
			}
		}else{
			this.warning = true;
		}
	}
}
